import type { RootState } from "../types/store";

function getStoreSync() {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  return require("../store").store as { getState: () => RootState };
}

export function authHeader() {
  const state = getStoreSync().getState();
  const user = state.auth?.user;
  if (user?.key) {
    return { "Content-Type": "application/json", Authorization: "Token " + user.key };
  }
  return {};
}
